import * as Flowbite from 'flowbite-react';
import { BaseInputProps } from '../types';
import { theme } from './theme';
import { IconInfoCircle } from '@tabler/icons-react';
import { Tooltip } from 'flowbite-react';

type CheckboxProps = BaseInputProps<boolean>;

export const Checkbox = ({
    onChange = () => {},
    label,
    value,
    color = 'primary',
    tooltip,
    ...props
}: CheckboxProps) => (
    <Flowbite.Label
        className="[&_input:disabled]:opacity-50 [&_input:disabled_+_*]:opacity-50 flex gap-2 items-center"
        color={color}
    >
        <Flowbite.Checkbox
            {...props}
            theme={theme}
            color={color}
            checked={value}
            onChange={(e) => !props.readOnly && onChange(e.target.checked)}
        />

        <div className="flex">
            <span className="block font-medium">{label}</span>
            {tooltip && (
                <Tooltip className="whitespace-pre-line" content={tooltip}>
                    <IconInfoCircle
                        size={16}
                        className="ml-1"
                        data-testid="info-icon"
                    />
                </Tooltip>
            )}
        </div>
    </Flowbite.Label>
);
